export class QuantitySelector {
  /**
   * Init needed events for quantity selector HTML elements from formular
   * @param {Node} prmQuantitySelector
   */
  constructor(form) {
    this.locale = document.documentElement.lang || navigator.language;
    this.form = form;
    this.quantitySelector = form.querySelector('.js-control');
    this.min = parseFloat(this.quantitySelector.getAttribute('min') || this.quantitySelector.dataset.min);
    this.max = parseFloat(this.quantitySelector.getAttribute('max') || this.quantitySelector.dataset.max);
    this.step = parseFloat(this.quantitySelector.getAttribute('step') || this.quantitySelector.dataset.step || 1);
    this.container = this.quantitySelector.closest('[data-mds="quantityselector"]');
    this.increaseBtn = this.container.querySelector('.js-increase');
    this.decreaseBtn = this.container.querySelector('.js-decrease');
    _quantitySelectorEvent.call(this, this.quantitySelector);
    if (form.querySelector('.js-unit-capacity-value')) {
      this.mode = 'DOUBLE';
      this.initDouble();
    }
    if (form.querySelector('.js-floor-quantity')) {
      this.mode = 'FLOORING';
      this.initFlooring();
    }
    this.form.dispatchEvent(new Event('THUMBNAIL_USER_QUANTITY_UPDATED'));
  }
  initDouble() {
    this.capacityValue = this.form.querySelector('.js-unit-capacity-value').value.replace(',', '.');
    this.inputCapacity = this.form.querySelector('.js-unit-capacity__input');

    // init inputCapacity
    _updateCapacity.call(this);
    this.quantitySelector.addEventListener('QUANTITY_UPDATED', () => {
      this.quantitySelector.value = this.quantitySelector.value.replace(/[^0-9]/g, '');
      _updateCapacity.call(this);
    });

    // watch change on capacity input
    this.inputCapacity.addEventListener('keyup', () => {
      this.inputCapacity.value = this.inputCapacity.value.replace(/[^0-9,.]/g, '');
      _updateQuantity.call(this);
    });
  }
  initFlooring() {
    this.factor = this.form.querySelector('input[name="factor"]').value;
    this.unitPrice = this.form.querySelector('input[name="unitPrice"]').value;
    this.currency = this.form.querySelector('input[name="currency"]').value;
    this.totalAmount = this.form.querySelector('.js-total-amount');
    this.lengthValue = this.form.querySelector('.js-length-value');
    this.lengthLabel = this.form.querySelector('.js-length-label');
    this.quantitySelector.addEventListener('QUANTITY_UPDATED', () => _setDatas.call(this));
  }
}

/**
 * _updateCapacity : update the capacity when quantity change
 */
function _updateCapacity() {
  try {
    this.quantitySelector.value = _acceptComma(this.quantitySelector.value);
    this.inputCapacity.value = this.quantitySelector.value * this.capacityValue;
    this.inputCapacity.value = Math.round(this.inputCapacity.value * 100) / 100;
    _disableButtons.call(this);
  } catch (error) {
    console.error('Error on updateQuantity', error);
  }
}

/**
 * _updateQuantity : update the quantity when capacity change
 */
function _updateQuantity() {
  try {
    this.inputCapacity.value = _acceptComma(this.inputCapacity.value);
    this.quantitySelector.value = Math.ceil(this.inputCapacity.value / this.capacityValue);
    _disableButtons.call(this);
  } catch (error) {
    console.error('Error on updateCapacity', error);
  }
}
function _getFlooringFormatedString(value) {
  const price = Math.round(value * this.unitPrice * 100) / 100;
  return `${price.toLocaleString(this.lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${this.currency}`;
}
function _setDatas() {
  const length = Math.floor(_getNumberValue.call(this) / this.factor * 100) / 100;
  this.lengthValue.textContent = length.toLocaleString(this.locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).replace(/[.,]00$/g, '');
  this.totalAmount.textContent = _getFlooringFormatedString.call(this, this.quantitySelector.value);
  this.lengthLabel.textContent = length >= 2 ? window.productthumbnail?.translation?.mtrPlural?.toLowerCase() || '' : window.productthumbnail?.translation?.mtrSingular?.toLowerCase() || '';
}

/**
 * Init event on input and element sibling near to it (buttons)
 */
function _quantitySelectorEvent() {
  _disableButtons.call(this);
  this.quantitySelector.addEventListener('UPDATE_STEP_QUANTITY', e => {
    if (e.detail.step && Number.isInteger(e.detail.step)) {
      this.step = e.detail.step;
    }
  });
  this.quantitySelector.addEventListener('keyup', () => {
    switch (this.mode) {
      case 'FLOORING':
        _setDatas.call(this);
        break;
      case 'DOUBLE':
        this.quantitySelector.value = this.quantitySelector.value.replace(/[^0-9]/g, '');
        _updateCapacity.call(this);
        break;
      default:
        break;
    }
    const value = _getNumberValue.call(this);
    this.quantitySelector.value = Math.max(value, this.min);
    this.quantitySelector.value = Math.min(value, this.max);
    _disableButtons.call(this);
  });
  this.decreaseBtn.addEventListener('click', event => {
    event.preventDefault();
    _decrement.call(this, this.step);
    _disableButtons.call(this);
    switch (this.mode) {
      case 'FLOORING':
        _setDatas.call(this);
        break;
      case 'DOUBLE':
        this.inputCapacity.value = Math.round(parseInt(this.quantitySelector.value) * this.capacityValue * 100) / 100;
        break;
      default:
        break;
    }
  });
  this.increaseBtn.addEventListener('click', event => {
    event.preventDefault();
    _increment.call(this, this.step);
    _disableButtons.call(this);
    switch (this.mode) {
      case 'FLOORING':
        _setDatas.call(this);
        break;
      case 'DOUBLE':
        this.inputCapacity.value = Math.round(parseInt(this.quantitySelector.value) * this.capacityValue * 100) / 100;
        break;
      default:
        break;
    }
  });

  // Keyboard interaction
  //(https://www.w3.org/TR/wai-aria-practices-1.1/#spinbutton)
  this.quantitySelector.addEventListener('keydown', event => {
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
        event.preventDefault();
        _decrement.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        event.preventDefault();
        _increment.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'PageUp':
        event.preventDefault();
        _increment.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'PageDown':
        event.preventDefault();
        _decrement.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'Home':
        event.preventDefault();
        _decrement.call(this, this.max);
        _disableButtons.call(this);
        break;
      case 'End':
        event.preventDefault();
        _increment.call(this, this.max);
        _disableButtons.call(this);
        break;
    }
  });
}

/**
 * Decrement the quantity by a specific amount
 */
function _decrement(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.max(value - amount, this.min);
}

/**
 * Increment the quantity by a specific amount
 */
function _increment(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.min(value + amount, this.max);
}

/**
 * Disabled buttons to step up or step down quantitySelector's value
 */
function _disableButtons() {
  this.form.dispatchEvent(new Event('THUMBNAIL_USER_QUANTITY_UPDATED'));
  const value = _getNumberValue.call(this);
  switch (value) {
    case this.min:
      this.decreaseBtn.disabled = true;
      this.increaseBtn.disabled = false;
      break;
    case this.max:
      this.decreaseBtn.disabled = false;
      this.increaseBtn.disabled = true;
      break;
    default:
      this.decreaseBtn.disabled = false;
      this.increaseBtn.disabled = false;
  }
}

/**
 * Return value with comma replace by point.
 * @returns {String}
 */
function _acceptComma(prmValue) {
  return prmValue.replace(/,/g, '.');
}

/**
 * Return the value of quantitySelector element passed as parameter
 * @returns {BigInt}
 */
function _getNumberValue() {
  return this.quantitySelector.value === '0' ? 0 : parseFloat(_acceptComma(this.quantitySelector.value)) || 1;
}